import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api, formatDate } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const SEEN_KEY = "velta_seen_release_id";

export const WhatsNew = () => {
  const { user } = useAuth();
  const [note, setNote] = useState(null);

  useEffect(() => {
    if (!user || user.role === "superadmin") return;
    api.get("/release-notes/latest").then((r) => {
      const n = r.data;
      if (!n || !n.id) return;
      const seen = localStorage.getItem(SEEN_KEY);
      if (seen === n.id) return;
      if (!seen) {
        localStorage.setItem(SEEN_KEY, n.id);
        return;
      }
      setNote(n);
    }).catch(() => {});
  }, [user]);

  if (!note) return null;

  const dismiss = () => {
    localStorage.setItem(SEEN_KEY, note.id);
    setNote(null);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[9998]">
      <div data-testid="whatsnew-modal" className="bg-white rounded-md w-full max-w-md overflow-hidden">
        <div className="bg-velta-ink text-white p-5">
          <div className="flex items-center gap-2 text-emerald-400 text-xs font-mono uppercase tracking-widest">
            <Sparkles className="w-4 h-4" /> App aggiornata
          </div>
          <h3 className="font-heading text-xl font-semibold mt-1.5" data-testid="whatsnew-title">{note.title}</h3>
          <div className="text-[11px] text-white/60 font-mono mt-0.5">{formatDate(note.created_at)}</div>
        </div>
        <ul className="p-5 space-y-2" data-testid="whatsnew-items">
          {(Array.isArray(note.items) ? note.items : []).map((it, i) => (
            <li key={i} className="text-sm flex gap-2">
              <span className="text-emerald-500 font-bold">✓</span>
              <span>{it}</span>
            </li>
          ))}
        </ul>
        <div className="p-5 pt-0">
          <button
            data-testid="whatsnew-dismiss-btn"
            onClick={dismiss}
            className="w-full h-11 bg-velta-ink text-white rounded-md font-medium hover:bg-[#162244]"
          >
            Ho capito
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNew;
